import { Icon } from "../../../../elements/Icon";
import { styles } from "./Item.style";

export interface IItemProps {
  image: { url: string; title?: string; description?: string; width?: number; height?: number };
  label: string;
}

export function Item({ image, label }: IItemProps) {
  return (
    <div className={styles.root()}>
      <Icon desc={image.description} icon={image.url} className={styles.icon()}></Icon>
      <div className={styles.label()}>{label}</div>
    </div>
  );
}
